import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-wrapper">
      <Sidebar open={sidebarOpen} />
      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="d-lg-none position-fixed inset-0"
          style={{ background: 'rgba(0,0,0,.4)', zIndex: 1049 }}
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <div className="main-content">
        <Topbar onMenuToggle={() => setSidebarOpen((v) => !v)} />
        <main className="page-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
